import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static values = { contents: String }

  declare contentsValue: string

  copyToClipboard() {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.contentsValue)
    } else {
      const temp = document.createElement("input")
      temp.type = "text"
      temp.value = this.contentsValue || ""
      temp.style.position = "absolute"
      temp.style.left = "-9999px"
      temp.setAttribute("readonly", "")
      document.body.appendChild(temp)
      temp.select()
      document.execCommand("copy")
      temp.remove()
    }
  }

  copyWithTooltip(event: Event) {
    event.preventDefault()
    this.copyToClipboard()
    const tt = Tooltip.getOrCreateInstance(this.element, {
      title: "Copied",
      trigger: "manual",
    })
    tt.show()
    setTimeout(() => tt.hide(), 1000)
  }

  copyWithClass(event: Event) {
    event.preventDefault()
    this.copyToClipboard()
    this.element.classList.add("copied")
    setTimeout(() => this.element.classList.remove("copied"), 1000)
  }
}
